<template>
  <b-modal id="files-list-modal" :modal-class="`adp-modal`" :body-class="`adp-modal-body`"
           :header-class="`adp-modal-header`" :footer-class="`adp-modal-footer d-flex justify-content-center`">
    <template #modal-title>
      <h5 class="modal-title adp-h2 adp-h2__modal">{{ learningActivityTitle }}</h5>
    </template>
    <div class="adp-p adp-p__grey" style="margin: -1.5rem 0 1.5rem">
      {{ files.length }} {{ $tc('idp.file', files.length) }}
    </div>
    <template #modal-header-close>
      <span aria-hidden="true"><img src="/images/cross.svg" alt=""></span>
    </template>
    <template>
      <div v-for="file in files" :key="file.id">
        <div class="adp-modal-files-block">
          <div class="adp-modal-files-block__icons">
            <span class="adp-modal-files-block__icons rectangle"><img src="/images/rectangle.svg" alt=""></span>
            <span class="adp-modal-files-block__icons paperclip"><img src="/images/paperclip.svg" alt=""></span>
          </div>
          <div class="adp-modal-files-block__title" @click="downloadFile(file)">
            <div style="overflow: hidden; text-overflow: ellipsis; max-width: 400px">{{ file.name }}</div>
            <div class="adp-p adp-p__grey">{{ $t(whoAttached(file)) }}</div>
          </div>
          <div class="adp-modal-files-block__trash" @click="deleteFile(file)" v-if="attachedByYou(file)">
            <img src="/images/trash.svg" alt="">
          </div>
        </div>
      </div>
    </template>
    <template #modal-footer>
      <button class="btn btn-primary adp-btn adp-btn__large" style="margin-left: auto" @click="attachNewFiles()">
        {{ $t('idp.cm_attach_new_files') }}
      </button>
    </template>
    <delete-file-question-modal :file-id="deletedFile.id"
                                :file-name="deletedFile.name"
                                :learning-activity-id="learningActivityId"
                                v-on:file-deleted="reload()"/>
    <attach-new-files-modal :learning-activity-id="learningActivityId"
                        :learning-activity-title="learningActivityTitle"
                        :viewer-pernumber="viewerPernumber"
                        v-on:files-attached="reload"/>
  </b-modal>
</template>

<script>
import api from "../../api";
import DeleteFileQuestionModal from "./DeleteFileQuestionModal";
import AttachFilesModal from "./AttachFilesModal";
import AttachNewFilesModal from "./AttachNewFilesModal";

export default {
  name: "FilesListModal",
  components: {AttachNewFilesModal, DeleteFileQuestionModal},
  props: {
    learningActivityTitle: {
      type: String,
      required: true,
    },
    learningActivityId: {
      type: Number,
      required: true,
    },
    viewerPernumber: {
      type: Number,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    }
  },
  data: () => {
    return {
      deletedFile: {
        id: 0,
        name: ''
      },
      currentRole: '',
    }
  },
  methods: {
    attachNewFiles() {
      this.$bvModal.show('attach-new-files-modal');
    },
    downloadFile(file) {
      api.downloadFile(file.id).then(response => {
        const url = URL.createObjectURL(response.data);
        const link = document.createElement('a')
        link.href = url;
        link.setAttribute('download', file.name);
        link.click();
      });
    },
    deleteFile(file) {
      this.deletedFile.id = file.id;
      this.deletedFile.name = file.name;
      this.$bvModal.show('delete-file-question-modal');
    },
    whoAttached(file) {
      if (this.currentRole !== file.role && file.role === 'hr') return 'modal.attached_by_hr';
      if (this.currentRole !== file.role && file.role === 'manager') return 'modal.attached_by_manager';
      if (this.currentRole !== file.role && file.role === 'employee') return 'modal.attached_by_employee';

      return 'modal.attached_by_you';
    },
    attachedByYou(file) {
      return file.user_pernumber === this.viewerPernumber;
    },
    reload() {
      this.$emit('file-deleted');

      this.$bvModal.hide('delete-file-question-modal');
      this.$bvModal.hide('files-list-modal');

      if (this.files.length > 1) this.$bvModal.show('files-list-modal');
    }
  },
  mounted() {
    this.currentRole = window.IDP.role;
  }
}
</script>

<style scoped>

</style>
